import { render, staticRenderFns } from "./CouponList.vue?vue&type=template&id=64ec2c30&scoped=true&"
import script from "./CouponList.vue?vue&type=script&lang=ts&"
export * from "./CouponList.vue?vue&type=script&lang=ts&"
import style0 from "./CouponList.vue?vue&type=style&index=0&id=64ec2c30&lang=scss&scoped=true&"
import style1 from "./CouponList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ec2c30",
  null
  
)

export default component.exports